export default "__VITE_ASSET__DnN5iSBe__"